<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { onMounted, ref, type Ref } from 'vue';
import KpSelectField from '@/components/KpSelectField.vue';
import { NutzungsartCollection, type Nutzungsart } from '@/models/Nutzungsart';
const value: Ref<any> = defineModel();

const emit = defineEmits(['copy']);

const targetNutzungsartId: Ref<number | null> = ref(null);
const nutzungsarten: Ref<Nutzungsart[]> = ref([]);
onMounted(async () => {
    const col = new NutzungsartCollection();
    col.setQueryParams({
        sort: [
            {
                property: 'reihenfolge',
                direction: 'asc',
            },
        ],
    });
    await col.query();
    col.each((m) => nutzungsarten.value.push(m));
});

function onCopy() {
    value.value = false;
    emit('copy', targetNutzungsartId.value);
}
</script>

<template>
    <Dialog
        v-model:visible="value"
        modal
        :header="$t('eintraege_kopieren')"
        :draggable="false"
        :style="{ width: '25rem' }"
    >
        <span class="text-surface-500 dark:text-surface-400 block mb-2rem">{{ $t('welche_ziel_nutzungsart') }}</span>
        <KpSelectField
            v-model="targetNutzungsartId"
            fluid
            :options="nutzungsarten"
            option-label="bezeichnung"
            option-value="id"
        ></KpSelectField>
        <div class="flex justify-content-end gap-2">
            <Button type="button" :label="$t('abbrechen')" severity="secondary" @click="value = false"></Button>
            <Button
                :disabled="!targetNutzungsartId"
                type="button"
                :label="$t('kopieren')"
                severity="success"
                @click="onCopy"
            ></Button>
        </div>
    </Dialog>
</template>
